type ReadinessState = { ready?: boolean; phase?: string } | null | undefined;

/**
 * Provisioning is expected to finish quickly. Poll fast only at the beginning,
 * then back off and stop after a bounded number of successful observations.
 */
export function projectReadinessPollInterval(
  readiness: ReadinessState,
  dataUpdateCount: number,
): number | false {
  if (readiness?.ready || readiness?.phase === "error") return false;
  if (dataUpdateCount < 6) return 2_000;
  if (dataUpdateCount < 12) return 5_000;
  if (dataUpdateCount < 24) return 10_000;
  return false;
}

export function operationPollInterval(
  status: string | null | undefined,
  dataUpdateCount: number,
): number | false {
  if (
    status && ["draft", "completed", "failed", "cancelled"].includes(status)
  ) return false;
  if (dataUpdateCount < 10) return 1_000;
  if (dataUpdateCount < 30) return 2_500;
  // Sync/promote může trvat dýl než první minuty (bundle + restart).
  // Zastavit poll u running = pruh visí na 100 % a náhled se neobnoví.
  return 5_000;
}
